/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */

import React from 'react'; // Importing React library to create components
import CustomModal from "../../../components/Modal/CustomModal";
import CustomDescriptionModal from "../../../components/CustomDescriptionModal";
import DisassignTemplateApp from "../Functionality/DisassignTemplateApp";

const DisassignTemplateModal = (props) => {
    const { onHide} = props; // Destructuring onHide from props
    const {
        t, // Translation function for text localization
        handleConfirm
    } = DisassignTemplateApp(props); // Destructuring from the CreateTemplateApp custom hook

    return (
        <CustomModal
            {...props}
            title={"disassign"}
            size="md"
            buttonConfirm={"disassign"}
            cancelButton={true}
            confirmButton={true}
            onConfirm={() => {
                onHide();
                handleConfirm();
            }}
            classNameBody="pt-2"
        >
            <div className={"row"}>
                <div className={"col-12"}>
                    <CustomDescriptionModal>
                        {t('are_you_sure_you_want_to_disassign_template')}
                    </CustomDescriptionModal>
                </div>
            </div>

        </CustomModal>
    );
};

export default DisassignTemplateModal; // Export the DisassignTemplateModal component for use in other parts of the app

